import AreaChart from "components/common/AreaChart/AreaChart";
import Typography from "components/common/Typography/Typography";
import { getChartDummyData } from "helpers/generateDummyChartData";
import {
  CHART_HEADING,
  CHART_SUBTITLE,
  GRAPH_API_CONNECTED,
  SHOW_CHART_HEADING,
} from "config/profile_constants";
import React from "react";
import Section from "../Layouts/Section";

const ProfileGraph = () => {
  const [chartData, setChartData] = React.useState([]);
  const getChartData = () => {
    if (GRAPH_API_CONNECTED) {
      // ATTACH API HERE
    } else {
      setChartData([...getChartDummyData(365)]);
    }
  };
  const init = () => {
    getChartData();
  };
  React.useEffect(() => {
    init();
  }, []);

  return (
    <Section heading={CHART_HEADING} showHeading={SHOW_CHART_HEADING}>
      {chartData.length > 0 ? <AreaChart chartData={chartData} /> : null}
    </Section>
  );
};

export default ProfileGraph;
